import React, { Component } from 'react';
import isContractInitialized from '../../utils/ContractInitializationState';
import LoadingAnimation from '../Components/LoadingAnimation';
import { TX_ERROR_GET_ETHER, TX_GET_ETHER } from '../../utils/TransactionTypes';
import {
  addTransactionInProgress,
  transactionErrorHandler,
  transactionReceiptHandler
} from '../../utils/TransactionStateHelper';

export default class GetEther extends Component {
  constructor (props) {
    super(props);

    this.state = {
      contractLoaded: false,
      smartContractHasEther: false
    };

    this.storageUnsubscribe = null;
  }

  componentDidMount () {
    this.isContractLoaded();
    this.storageUnsubscribe = Storage.subscribe(() => this.isContractLoaded());
    this.checkDoesContractHasEthereum();
  }

  isContractLoaded () {
    isContractInitialized() && !this.state.contractLoaded && this.init();
  }

  componentWillUnmount () {
    this.storageUnsubscribeHandler();
  }

  storageUnsubscribeHandler () {
    this.storageUnsubscribe && this.storageUnsubscribe();
  }

  init () {
    this.storageUnsubscribeHandler();
    this.setState({
      contractLoaded: true
    });

    this.storageUnsubscribe = Storage.subscribe(() => this.checkDoesContractHasEthereum());
  }

  checkDoesContractHasEthereum () {
    this.setState({
      smartContractHasEther: +Storage.getState().account.contractEthereumBalance >= 1
    });
  }

  handleGettingEther = (event) => {
    // We don't want normal page submit
    event.preventDefault();

    window.contract
      .methods
      .getEtherFromContract()
      .send({
        from: Storage.getState().account.currentAccount, gasPrice: 0
      })
      .on('transactionHash', (hash) => addTransactionInProgress(hash, TX_GET_ETHER, TX_ERROR_GET_ETHER))
      .on('receipt', (receipt) => transactionReceiptHandler(receipt, () => {
        this.setState({
          ether: ''
        });

        window.notifications.showSuccess('Ether successfully sent.');
      }))
      .on('error', (err, receipt) => transactionErrorHandler(err, receipt));
  };

  renderForm () {
    if (!this.state.contractLoaded) {
      return (<LoadingAnimation/>);
    }

    if (!this.state.smartContractHasEther) {
      return (<h4>Smart contract doesn't have any Ether.</h4>);
    }

    return (
      <form onSubmit={this.handleGettingEther}>
        <div className="c-form-row">
          <button type="submit">Get 1 Ether</button>
        </div>
      </form>
    );
  }

  render () {
    return (
      <div className="c-component c-get-ether">
        <h2>Get Ether</h2>
        {this.renderForm()}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/EtherPage/GetEther.js